export default __webpack_public_path__ + "static/media/BMMF03.e421d7bc.png";